"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CtaButtonGroup_1 = require("./CtaButtonGroup");
exports.default = CtaButtonGroup_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CtaButtonGroup/index.js
// module id = 160
// module chunks = 8